import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Button, Spin } from 'antd'
import { useHistory } from 'react-router-dom'

import DealDashboardActions from '../../../Redux/DealDashboardRedux'
import Images from '../../../Images'
import '../PopupPage.less'

function DealClosedPopupPage(props) {
  const { result, dealClosedResult, fetching, match, location } = props;
  const { dashboardId } = match.params;
  const { state } = location;

  const history = useHistory();

  useEffect(() => {
    props.dealDashboardSyncToggle(false);
  }, [0]);

  useEffect(() => {
    if (result) {
      props.viewDealClosedAdvisor(dashboardId);
    }
  }, [result]);

  useEffect(() => {
    if (dealClosedResult) {
      props.resetDealDashboard();
      history.push(`/home/deals`);
    }
  }, [dealClosedResult]);

  const removeNotification = () => {
    if (state?.isHistory) {
      props.dealDashboardSyncToggle(true);
      history.push(`/deal-dashboard/overview/${dashboardId}`);
    } else {
      props.changeNotificationStatus(state?.notification)
    }
  }

  return (
    <div className="popup-dialog">
      <div className="dialog-container" style={{ width: 420 }}>
        <Spin spinning={fetching} size="large">
          <div className="dialog-content" style={{ padding: 40, paddingTop: 20, paddingBottom: 30 }}>
            <img src={Images.phoneOk} alt="" />
            <div className="dialog-title welcome" style={{ margin: 6 }}>Deal Closed</div>
            <div className="deal-text engagment" style={{ marginTop: 14 }}>We are delighted to inform you that the <br /> Investor has successfully closed the deal.</div>
            <div className="deal-subtext engagment" style={{ marginTop: 14 }}>IDN’s team will be in touch shortly to confirm the <br /> success fee amount. In the meantime, feel free to <br /> get in touch with your IDN's Partner Manager in <br /> case you have any question.</div>
            <div className="btn-footer">
              <Button type="primary white"
                className="btn-primary welcome"
                style={{ width: 144 }}
                onClick={removeNotification}
              >
                {state?.isHistory ? 'Go back' : 'Continue'}
              </Button>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    result: state.dealDashboard.result,
    dealClosedResult: state.dealDashboard.dealClosedResult,
    fetching: state.dealDashboard.fetching
  }
}

const mapDispatchToProps = (dispatch) => ({
  changeNotificationStatus: (notificationId) => dispatch(DealDashboardActions.notificationChangeStatusRequest(notificationId)),
  viewDealClosedAdvisor: (dashboardId) => dispatch(DealDashboardActions.advisorSeenClosedDealRequest(dashboardId)),
  dealDashboardSyncToggle: (syncIsStart) => dispatch(DealDashboardActions.dealDashboardSyncToggle(syncIsStart)),
  resetDealDashboard: () => dispatch(DealDashboardActions.dealDashboardReset()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DealClosedPopupPage)
